export class ListSensitivityAnnotationsResponse {
    'sensitivityAnnotations';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sensitivityAnnotations",
            "baseName": "sensitivityAnnotations",
            "type": "Array<SensitivityAnnotation>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSensitivityAnnotationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
